import {
  checkoutV202604,
  type operations,
} from "@fluid-app/checkout-api-client";

import { createCheckoutApiClient } from "@/lib/checkout-api-client";

type ListUserCompaniesQuery =
  operations["checkout_v2026_04_list_users"]["parameters"]["query"];

export type ListUserCompaniesResponse =
  operations["checkout_v2026_04_list_users"]["responses"][200]["content"]["application/json"];

export type UserCompany = ListUserCompaniesResponse["user_companies"][number];

export async function listUserCompanies({
  page,
  per_page,
  search_query,
  sorted_by,
  role,
  by_metadata,
  jwt,
}: {
  page?: number;
  per_page?: number;
  search_query?: string;
  sorted_by?: string;
  role?: string;
  by_metadata?: string;
  jwt: string;
}) {
  const params = {
    page,
    per_page,
    search_query,
    sorted_by,
    role,
    by_metadata,
  } satisfies ListUserCompaniesQuery;

  try {
    return await checkoutV202604.checkout_v2026_04_list_users(
      createCheckoutApiClient(jwt),
      params,
    );
  } catch (error) {
    console.error("Error calling reps API:", error);
    throw error;
  }
}
